export default __webpack_public_path__ + "static/media/p2-2.237fd39f.png";